import * as R from 'ramda'
import * as React from 'react'
import PropTypes from 'prop-types'

import * as Common from '@rushplay/common'

import * as ServerConfiguration from './server-configuration'

export const currencies = {
  CAD: Common.CAD,
  EUR: Common.EUR,
  JPY: Common.JPY,
  SEK: Common.SEK,
  USD: Common.USD,
  UBT: Common.UBT,
}

const AmountRenderer = Common.createAmountComponent({
  currencies: R.values(currencies),
})

export function Amount(props) {
  const configuration = ServerConfiguration.useContext()

  return (
    <AmountRenderer
      {...props}
      currency={props.currency || configuration.currency.code}
      locale={props.locale || configuration.locale.slug}
    />
  )
}

Amount.propTypes = {
  currency: PropTypes.string,
  locale: PropTypes.string,
}
